import { Record } from 'immutable';

export default class RevisionMeta extends Record( {
	status: 'done',
	error: undefined,
	interaction: true
}, 'RevisionMeta' ) {}



// WEBPACK FOOTER //
// ./src/entities/revision-meta.js